export const completeParts = [
  {
    type: 'actions',
    actions: ['share', 'pinLeft', 'bell'],
    views: 432
  }
];
